import { useState } from 'react'
import { animated, useTransition } from '@react-spring/web'

import SeeToggle from './SeeToogle'
import InformationContent from './InformationContent'
import { composeClasses } from '@wiggot/utils/src/strings'

interface Props {
  className?: string
  openDirection?: 'top' | 'bottom',
  contentClassName?: string
}

const ZoneInformationBySearchAccordion = ({
  className = '',
  openDirection = 'bottom',
  contentClassName = '',
}: Props): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false)

  const transition = useTransition(isExpanded, {
    from: {
      height: 0,
    },
    enter: {
      height: 254,
    },
    leave: {
      height: 0,
    },
    config: {
      clamp: true,
      tension: 220,
      friction: 20,
      mass: 0.5,
      precision: 0.2,
      velocity: 0,
    },
  })

  return (
    <div
      className={composeClasses(
        'bg-white rounded-xl w-full overflow-hidden',
        isExpanded ? 'shadow-2xl' : '',
        className
      )}
    >
      <div
        className={composeClasses(
          'w-full flex flex-col bg-white rounded-b-xl',
         isExpanded ? 'border border-[#EBEDF0] rounded-xl shadow-2xl pr-[1px] pb-[1px]' : '',
          contentClassName
         )}
      >
        <div>
          {transition((style, isActive) =>
            isActive && openDirection === 'top' ? (
              <animated.div style={style} className="overflow-y-hidden">
                <InformationContent />
              </animated.div>
            ) : null
          )}

          <div>
            <SeeToggle
              isExpanded={isExpanded}
              expandedDirection={openDirection}
              onClick={() => {
                setIsExpanded(!isExpanded)
              }}
            />
          </div>

          {transition((style, isActive) =>
            isActive && openDirection === 'bottom' ? (
              <animated.div
                style={style}
                className="max-h-[calc(40vh)] overflow-y-auto"
              >
                <InformationContent />
              </animated.div>
            ) : null
          )}
        </div>
      </div>
    </div>
  )
}

export default ZoneInformationBySearchAccordion
